var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',[_c('div',{class:[_vm.getNameAttributeClassNames]},[(!_vm.showNameAttribute)?_c('InputValidator',{attrs:{"config":{
        attribute: 'name',
        label: _vm.inputLabel,
        name: _vm.nameAttributeName,
        placeholder: _vm.namePlaceholder,
        readonly: _vm.isReadOnly(_vm.nameReadOnly),
        type: 'text',
        validate: _vm.nameValidation,
        value: _vm.listItem.name,
      }},on:{"InputValidatorModel":(index, listItem) => _vm.handleInputChange(index, listItem, 'name')}}):_vm._e(),_vm._t("attributeInputLabel")],2),_c('div',{class:[_vm.getValueAttributeClassNames]},[_c(_vm.valueDynamicComponent,_vm._b({tag:"component",attrs:{"config":{
        attribute: 'value',
        label: _vm.dropdownLabel,
        name: _vm.valueAttributeName,
        placeholder: _vm.showNameAttribute ? _vm.listItem.name : _vm.valuePlaceholder,
        readonly: _vm.isReadOnly(_vm.valueReadOnly),
        type: 'text',
        validate: _vm.valueValidation,
        value: _vm.listItem.value,
      }},on:{"InputValidatorModel":(index, listItem) => _vm.handleInputChange(index, listItem, 'value')}},'component',_vm.valueDynamicComponentProps,false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }